import React, { useEffect, useState } from 'react'
import cx from 'classnames'

import cm from './PhoneContainer.module.css'

const PhoneContainer = React.forwardRef<HTMLDivElement | null, { show: boolean }>(
  ({ show }, ref) => {
    const [shouldRender, setShouldRender] = useState(show)

    useEffect(() => {
      if (show) {
        setShouldRender(true)
      }
    }, [show])

    const onAnimationEnd = () => {
      if (!show) {
        setShouldRender(false)
      }
    }

    return shouldRender ? (
      <div
        className={cx(cm.phone, { [cm.applyShowAnimation]: show, [cm.applyHideAnimation]: !show })}
        ref={ref}
        onAnimationEnd={onAnimationEnd}
      />
    ) : null
  },
)

export default PhoneContainer
